// #3188 APPROVE.5 — Settings → Escalation: "Allow proceed at risk after final
// escalation" (design v1.1 §4.6, §5.5; R-6). One control, used at the tenant
// level (SettingsPage) and the project level (EscalationOverridesSidebarCard).
//
// The parent renders it only when the escalation-rules GET carries the
// `allowProceedAtRisk` key on the CLIENT_APPROVAL_OVERDUE row. The API sends
// that key only once CLIENT_APPROVAL_ENFORCEMENT_LIVE is true (ruling
// 6564192780, rule 1), so until 3b flips it the toggle is hidden and the page
// renders exactly as before, with no extra request.

interface Props {
  /** This level's own value; null = inherited from the level above. */
  stored: boolean | null;
  /** The value in force here (this level's, or the inherited one). */
  effective: boolean;
  disabled: boolean;
  /** true / false sets this level; null clears it (inherit). */
  onChange: (value: boolean | null) => void;
}

export const PROCEED_AT_RISK_LABEL = 'Allow proceed at risk after final escalation';

export default function ProceedAtRiskSetting({ stored, effective, disabled, onChange }: Props) {
  return (
    <div data-testid="proceed-at-risk-setting" style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 6, flexWrap: 'wrap' }}>
      <input
        type="checkbox"
        checked={effective}
        onChange={() => onChange(!effective)}
        disabled={disabled}
        data-testid="proceed-at-risk-toggle"
        aria-label={PROCEED_AT_RISK_LABEL}
        style={{ accentColor: 'var(--primary)', cursor: disabled ? 'not-allowed' : 'pointer' }}
      />
      <span style={{ fontFamily: 'var(--font-body)', fontSize: 13, color: 'var(--text)' }}>{PROCEED_AT_RISK_LABEL}</span>
      {stored === null ? (
        <span data-testid="proceed-at-risk-inherited" style={{ fontFamily: 'var(--font-body)', fontSize: 11, color: 'var(--text-secondary)' }}>
          (inherited)
        </span>
      ) : (
        <button
          type="button"
          onClick={() => onChange(null)}
          disabled={disabled}
          data-testid="proceed-at-risk-revert"
          style={{
            padding: '2px 8px', fontSize: 11, fontWeight: 500, borderRadius: 4,
            border: '1px solid var(--border)', background: 'transparent', color: 'var(--text-secondary)',
            cursor: disabled ? 'not-allowed' : 'pointer',
          }}
        >
          Use inherited value
        </button>
      )}
    </div>
  );
}
